<template>
<div style="margin:5px;">
      <br>
     <Row><Col span="12" offset="10"><div class="myTitle" >通讯录列表</div></Col></Row>
           
     
      <Row >
          <Col span="10" offset="1">
            <div>
              <Button type="info"  @click="openAddForm" >新增</Button>
            </div>
          </Col>
      </Row>
      <br>
      <Row>
          <Col span="24">
              <Table :loading="loading" @on-selection-change="selectRow" 
                border ref="table" stripe :columns="columns4" :data="listData">
                <template slot-scope="{ row }" slot="name">
                  <strong>{{ row.name }}</strong>
                </template>
                <template slot-scope="{ row }" slot="action">
               
                  <Button type="info" size="small" @click="openUpdateForm(row)">修改</Button>
                  <Button type="error" size="small" @click="deleleRows(row)">删除</Button>
                </template>
              </Table>
          </Col>
      </Row>
      <Row>
        <Col span="24">
          <div>
            <Footer>
              <Page show-sizer show-total :total="rowCount" :current="current"
                :page-size="pageSize"  @on-change="changePage"
                @on-page-size-change="changeSize" />
            </Footer>
          </div>
        </Col>
    </Row>
  <mailEdit ref="mailEdit"></mailEdit>
 
</div>
</template>

<script>

  import mailEdit from '@/pages/platform/mail/mailEdit';


  export default {
    components: {
        mailEdit
    },
    methods: {
    
      selectRow(selection) {
        this.selectRows = selection;
      },
      //打开新增对话框
      openAddForm() {
        this.$refs.mailEdit.openModal('新增',null);
      },
      //打开修改对话框
      openUpdateForm(row) {
         this.$refs.mailEdit.openModal('修改',row);
       
      },
 
    
    

      //执行删除操作
            deleleRows(row) {
               
                this.$Modal.confirm({
                    title: '删除',
                      content: `确认要删除\"${row.name}\"吗?`,
                    onOk: () => {
                         this.loading = true
                         let url = `/api/address`
                            this.req({
                                url: url,
                                method: 'delete',
                                data: {
                                    _id: row._id
                                }
                            }).then(response => {
                                this.$Message.success(
                                {
                                    content:response.data.msg,
                                    top: 80,
                                    onClose: ()=>{
                                        this.loading = false
                                        this.loadPage();
                                    }
                                }
                                )
                        }).catch(error => {
                                this.$Message.error('服务器错误:' + error)
                        })
                    },
                    onCancel: () => {
                       // this.loading = false
                    }
                });

            },
      
      loadPage() {
         this.loading = false
        let url   = `api/address`
        this.req({
          url: url,
          method: 'post',
          data:{
            p: this.current,
            pageSize: this.pageSize,
            type: 2
          }
        }).then(resp => {
          this.buildPageData(resp.data.page)
          this.loading = false
        }).catch(error => {
          this.$Message.error('服务器错误2:' + error);
        })
      },
      changePage(curPage) {
        this.loading = true
        this.current = curPage
        this.loadPage()
      },

      changeSize(pageSize) {
        this.pageSize = pageSize
        this.loading = true
        this.loadPage()
      },
      buildPageData(dataObj) {
        this.listData = dataObj.list;
        this.pageSize = dataObj.size;
        this.rowCount = dataObj.rowCount;
        this.currentPage = dataObj.p;
      },
      resetQueryForm() {
        this.$refs["queryFormRef"].fields.forEach(function (e) {
           e.resetField()
        })
      },
       queryBtn(){
            this.current = 1
            this.loadPage()
        },
   
     
     
    },
    mounted: function () {
      this.loadPage()
       this.loading = false
    },
    data() {
      return {
        listData: [],
        pageSize: 10,
        current: 1,
        rowCount: 0,
        loading: true,
        deleteId: '',
        showcity: true,
        showcountry: true,
        columns4: [{
            type: 'index',
            title:'序号',
            width: 70,
            align: 'center',
          },
          {
            title: '姓名',
            align: 'center',
            key: 'name',
          },
          {
            title: '单位',
            align: 'center',
            key: 'unit'
          },
           {
            title: '职位',
            align: 'center',
            key: 'job'
          },
           {
            title: '手机号',
            align: 'center',
            key: 'phone'
          },
          {
            title: '邮箱',
            align: 'center',
            key: 'email'
          },
           {
            title: 'QQ号',
            align: 'center',
            key: 'qq'
          },
          {
            title: '微信号',
            align: 'center',
            key: 'wechat'
          },
          {
            title: '操作',
            slot: 'action',
            width: 180,
            align: 'center'
          }
        ],
        //查询表单的初始值
        queryForm: {
          queryStartDate: '',
          queryEndDate:'',
          ip: '',
          username: '',
        },
      }
    },

  }
</script>

<style scoped>
  .ivu-layout-header {
    background: #f5f7f9;
  }

 

  .queryForm {
    padding: 10px;
  }
  .queryBtn {
    padding-bottom: 5px;
    padding-left: 700px;
    border-bottom: rgb(160, 146, 146) solid 1px;
  }
  .optBtn {
    margin: 10px;
  }
  .ivu-form-item {
    margin-bottom: 0px;
  }
  .a {
    color: #fff;
  }
   .myTitle{
      font-size: 20px;
      font-weight: 700;
  }
</style>


// WEBPACK FOOTER //
// src/pages/platform/mail/mailList.vue